const LOAD_DETAIL_AGENCIES           = 'LOAD_DETAIL_AGENCIES'
const LOAD_DETAIL_AGENCIES_SUCCESS   = 'LOAD_DETAIL_AGENCIES_SUCCESS'
const LOAD_DETAIL_AGENCIES_FAILED    = 'LOAD_DETAIL_AGENCIES_FAILED'
const UNMOUNT_DETAIL_AGENCIES        = 'UNMOUNT_DETAIL_AGENCIES'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const agenciesDetailReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_AGENCIES:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_AGENCIES_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_AGENCIES_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_AGENCIES:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default agenciesDetailReducer;